import { PIEVE_MODEL_MAP } from '@shared/pieve/modelCatalog.js';
import { resolvePieveModelId } from '@shared/pieve/modelSelection.js';
import { DEFAULT_PIEVE_MODEL_ID } from '@shared/pieve/defaultModel.js';

const getModelCapabilitySnapshot = ({ modelId } = {}) => {
  const resolvedId = resolvePieveModelId(modelId || DEFAULT_PIEVE_MODEL_ID);
  const config = PIEVE_MODEL_MAP[resolvedId];

  return {
    modelId: resolvedId,
    provider: config?.provider || 'openai',
    modelFamily: config?.modelFamily || 'openai.codex',
    capabilities: config?.capabilities || null
  };
};

export default getModelCapabilitySnapshot;
